export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Ordine scaduto",
      "649f8aefc1c0": "Riciclaggio non riuscito",
      "649f8aefc9c0": "Ottieni un nuovo preventivo",
      "TradeIn": "Processo di permuta",
      "logistic": "Scarica l'etichetta di spedizione",
      "start": "Inizia il percorso",
      "success": "Hai confermato con successo la ricezione del nuovo dispositivo",
      "qc": "Controllo qualità del vecchio dispositivo",
      "business": "Completeremo l'ispezione del tuo vecchio dispositivo entro 3 giorni lavorativi",
      "completed": "Completato",
      "successfully": "Congratulazioni, la tua permuta è andata a buon fine",
      "orderInfor": "Informazioni sull'ordine",
      "orderID": "ID ordine di permuta",
      "orderNum": "ID ordine di acquisto del nuovo dispositivo",
      "createTime": "Data di creazione",
      "brand": "Marca stimata",
      "model": "Modello stimato",
      "price": "Valore del vecchio dispositivo",
      "bonus": "Bonus",
      "reclaimFailure": "Poiché il dispositivo non è stato spedito entro 10 giorni dalla ricezione, l'ordine di riciclaggio è scaduto ed è stato annullato. Se desideri completare il riciclaggio del vecchio dispositivo, puoi cliccare il pulsante qui sotto per visualizzare l'ultimo preventivo.",
      "total": "Prezzo totale",
      "logisticInfo": "Informazioni logistiche",
      "available": "Nessuna informazione logistica disponibile",
      "logisticNum": "Numero logistico",
      "failRey": "Ci dispiace che la tua partecipazione al programma di riciclaggio OnePlus non sia stata completata con successo. Se desideri riciclare altri dispositivi elettronici, puoi cliccare il pulsante qui sotto per ottenere una valutazione rapida!",
      "userRes": "L'utente ha già rifiutato l'offerta.",
      "successPrice": "Il seguente prezzo è stato determinato dopo un'ispezione professionale. Se accetti questo prezzo, potrai procedere con la permuta. Se lo rifiuti, il dispositivo ti sarà restituito entro pochi giorni lavorativi.",
      "sure": "Accetta",
      "Reject": "Rifiuta",
      "congratulation": "Congratulazioni, nessuna differenza rilevata durante il controllo qualità.",
      "finPirce": "Prezzo finale",
      "copySuccess": "Copiato con successo",
      "copyfail": "Copia non riuscita",
      "sureSuccess": "Conferma transazione completata con successo",
      "submitError": "Invio non riuscito",
      "detectionResult": "Risultato dell'ispezione",
      "Collected": "Effettua un ordine",
      "inTransit": "In transito",
      "656g0lj3sav6": "Processo di riciclaggio",
      "656g0lj3cd5a": "Compila correttamente le tue informazioni personali e completa con successo l'ordine",
      "656g0lj3dr9a": "L'ispezione del tuo telefono verrà completata entro 48 ore dal suo arrivo presso il nostro centro",
      "656g0lj3epal": "Una volta completata l'ispezione, ti contatteremo via e-mail con l'offerta finale",
      "656g0lj3pda2": "La tua valutazione",
      "656g0lj3ed3d": "Controllo qualità professionale",
      "656g0lj3esf3": "Copia",
      "expertDiscount": "Codice promozionale",
      "invalidCode": "Codice non valido",
      "toastTip": "Seleziona per accettare l'Informativa sulla privacy e i Termini.",
      "649f8aef26sf": "Processo di permuta",
      "checkTitle": "Informazioni sul test",
      "basicInformation": "Informazioni di base",
      "understand": "Ho capito",
      '656g0lj3sf6e': 'I bonus promozionali sono offerti e gestiti dai marchi associati. Verranno corrisposti separatamente e non fanno parte della valutazione del dispositivo usato.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Rifiuta il riciclaggio",
      "64a9shqq3k00": "Confermi di rifiutare il riciclaggio",
      "64a9shqq3r00": "Annullamento riuscito",
      "64a9shqq3ws0": "Annullamento non riuscito",
      "sureCancel": "Conferma annullamento"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Chi",
      "646u995lv9g0": "siamo?",
      "646u9d5lv9g0": "Danghuan è un'azienda con attività principale incentrata sul riciclo, lo smaltimento e la vendita di prodotti digitali 3C come telefoni, tablet, laptop e orologi. La nostra azienda si dedica a migliorare l'efficienza del riciclo dei prodotti elettronici e a promuovere uno sviluppo sano del mercato dell'usato. Attualmente abbiamo stretto partnership strategiche ufficiali con OPPO, Vivo, OnePlus, Realme e altri. Le nostre attività internazionali si sono estese in India, Thailandia, Vietnam, Cambogia e ora anche in Europa.",
      "646u995dv9g0": "La nostra presenza globale ci ha posizionati come partner strategico per operatori di telefonia mobile, produttori e grossisti con una portata sia continentale che transcontinentale.",
      "646u99slv9g0": "Collaboriamo con i principali produttori e manteniamo un inventario diversificato che include dispositivi di fascia bassa, media e alta. Questo ci consente di offrire soluzioni personalizzate e prezzi competitivi per soddisfare le esigenze dei nostri clienti."
    },
    "business": {
      "646v04syvpk0": "Sei interessato ad acquistare il nostro stock?",
      "646v04syxs80": "In Danghuan offriamo un'ampia selezione di telefoni, tablet e smartwatch, disponibili in vari livelli di classificazione per soddisfare differenti esigenze commerciali.",
      "646v04syy6g0": "Contatta il nostro Responsabile Vendite e Acquisti:",
      "646v04syya80": "Voglio acquistare",
      "646v04syydg0": "Inserisci il tuo nome",
      "646v04syyh40": "Inserisci il tuo numero di telefono",
      "646v04syyyw0": "Inserisci la tua e-mail",
      "646v0gsyz1s0": "Paese:",
      "646v04syz1s0": "Seleziona un'opzione",
      "646v04syz4o0": "Ho letto e accetto",
      "646v04syzkc0": "l'Informativa sulla privacy",
      "646v04syzok0": "Contattaci",
      "646v04syzvo0": "Inserisci il tuo numero di telefono",
      "646v04syzys0": "Inserisci la tua e-mail",
      "646v04sz01o0": "Inserisci un'e-mail valida",
      "646v04sz04g0": "Inserisci il tuo nome",
      "646v04sz0740": "Seleziona la casella per accettare l'informativa sulla privacy",
      "646v04sz0a00": "Invio riuscito",
      "646v04sz0cw0": "Invio non riuscito",
      "title1": "Classificazione trasparente dei dispositivi mobili",
      "text1-1": "Per supportare le tue decisioni di acquisto, ti invitiamo a consultare il nostro documento di classificazione dettagliato. Esso descrive gli standard estetici e funzionali di ogni grado, consentendoti di fare scelte informate in linea con le tue aspettative.",
      "title2": "Assistenza clienti eccezionale",
      "text2-1": "Riconosciamo le esigenze uniche di ogni cliente, motivo per cui il nostro team di professionisti multilingue è dedicato a fornire supporto personalizzato e competente.",
      "title3": "Impegno per la tecnologia sostenibile",
      "text3-1": "Siamo impegnati a promuovere l'accesso globale a soluzioni tecnologiche sostenibili, garantendo che i nostri processi creino valore per tutte le parti coinvolte.",
      "text3-2": "Per ulteriori informazioni o per organizzare un ordine di prova, contattaci. Il nostro team è pronto ad assisterti con professionalità e attenzione."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Ricevi il pagamento rapidamente in soli 4 passaggi",
      "s1": "Primo passaggio",
      "s1t": "Imballa il dispositivo in modo che arrivi nelle stesse condizioni in cui è stato spedito.",
      "s2": "Secondo passaggio",
      "s2t": "Consegnalo in uno dei nostri punti di raccolta.",
      "s3": "Terzo passaggio",
      "s3t": "Verifichiamo il tuo dispositivo e ti forniamo un preventivo.",
      "s4": "Quarto passaggio",
      "s4t": "Ricevi il pagamento rapidamente."
    },
    "section3": {
      "646tmse2fbo0": "Smartphone",
      "646tmse2mv00": "Rimani aggiornato",
      "section3-text2": "Tablet",
      "section3-text4": "Orologi",
      "section3-text5": "Altri dispositivi",
      "title": "Valutazione rapida",
      "t1": "Seleziona la tipologia e avvia la valutazione per ottenere un preventivo equo.",
      "t2": "Pochi passaggi semplici per usufruire del nostro servizio di riciclo veloce!"
    },
    "section6": {
      "646txzpazuc0": "Informazioni su Danghuan",
      "666txzpazuc0": "Un'azienda specializzata nel riciclo e nel riutilizzo di smartphone, tablet e altri dispositivi digitali, dedicata a offrire un processo di servizio semplice, sicuro ed efficiente, permettendo a ogni cliente di riciclare facilmente il proprio dispositivo usato.",
      "646txzpb0rk0": "Dettagli",
      "646txzpb0xc0": "Riciclo per 12 marchi"
    },
    "section7": {
      "646ns2k5f7k0": "Il nostro servizio è sempre disponibile",
      "646ns2k5gmw0": "Assistenza clienti: dal lunedì al venerdì dalle 9:00 alle 18:00 CET (UTC+1:00) Madrid, Spagna",
      "646ns2k5gs40": "Inserisci il tuo nome",
      "646ns2k5gx40": "Inserisci il tuo numero di telefono",
      "646ns2k5img0": "Inserisci la tua e-mail",
      "646ns2k5isw0": "Scrivici un messaggio prima che ti contattiamo",
      "646ns2k5iws0": "Contattaci",
      "646ns2k5j140": "Inserisci il tuo numero di telefono",
      "646ns2k5j4g0": "Inserisci la tua e-mail",
      "646ds2k5j4g0": "E-mail",
      "646ns2k5j6c0": "Inserisci un'e-mail valida",
      "646ns2k5j8g0": "Contattaci",
      "646ns2k5jak0": "C.I.F :",
      "646ns2k5jck0": "Indirizzo",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, Spagna",
      "646ns2k5jgc0": "Inserisci il tuo nome",
      "646ns2k5ji40": "Seleziona la casella per accettare l'informativa sulla privacy",
      "646ns2k5jk00": "Invio riuscito",
      "646ns2k5jm80": "Invio non riuscito",
      "646ny1rgz3c0": "Ho letto e accetto ",
      "646ny1rh2k40": "l'Informativa sulla privacy"
    },
    "successMain": {
      "647qmd42l1s0": "Ordine ricevuto con successo!",
      "647qmd42mss0": "Ti invitiamo a controllare l'e-mail con le istruzioni di spedizione inviata da no-reply@danghuan.eu. Se non l'hai ricevuta, controlla la cartella SPAM o contatta il nostro servizio clienti all'indirizzo insta360@danghuan.eu.",
      "647qmd42mz80": "La nostra offerta",
      "647qmd42yeo0": "Consigli prima della spedizione",
      "orderTime": "Data dell'ordine",
      "text1": "Spedizione gratuita",
      "text2": "Ti invitiamo a prestare attenzione al documento di spedizione inviato via e-mail.",
      "text3": "Backup dei dati",
      "text4": "Per proteggere i tuoi dati, effettua un backup e cancella o inizializza tutti i dati dal dispositivo.",
      "text5": "Ricarica",
      "text6": "Ti preghiamo di caricare il telefono almeno all'1% prima della spedizione per velocizzare l'ispezione.",
      "downloadDec": "Si prega di scaricare la Dichiarazione di integrità."
    },
    "tradeInProcess": {
      "649f8aefats0": "Ordine scaduto",
      "649f8aefc1c0": "Riciclaggio non riuscito",
      "649f8aefc9c0": "Ottieni un nuovo preventivo",
      "TradeIn": "Processo di permuta",
      "logistic": "Scarica l'etichetta di spedizione",
      "start": "Inizia il percorso",
      "success": "Hai confermato con successo la ricezione del nuovo dispositivo",
      "qc": "Controllo qualità del vecchio dispositivo",
      "business": "Completeremo l'ispezione del tuo vecchio dispositivo entro 3 giorni lavorativi",
      "completed": "Completato",
      "successfully": "Congratulazioni, la tua permuta è andata a buon fine",
      "orderInfor": "Informazioni sull'ordine",
      "orderID": "Numero ordine di riciclaggio",
      "orderNum": "ID ordine di acquisto del nuovo dispositivo",
      "createTime": "Data di creazione",
      "brand": "Marca stimata",
      "model": "modello",
      "price": "Valore del vecchio dispositivo",
      "bonus": "Bonus",
      "total": "Prezzo totale",
      "logisticInfo": "Informazioni logistiche",
      "available": "Nessuna informazione logistica disponibile",
      "logisticNum": "Numero logistico",
      "failRey": "Ci dispiace che la tua partecipazione al programma di riciclaggio OnePlus non sia stata completata con successo. Se desideri riciclare altri dispositivi elettronici, puoi cliccare il pulsante qui sotto per ottenere una valutazione rapida!",
      "userRes": "L'utente ha già rifiutato l'offerta.",
      "successPrice": "Il seguente prezzo è stato determinato dopo un'ispezione professionale. Se accetti questo prezzo, potrai procedere con la permuta. Se lo rifiuti, il dispositivo ti sarà restituito entro pochi giorni lavorativi.",
      "sure": "Accetta",
      "Reject": "Rifiuta",
      "congratulation": "Congratulazioni, nessuna differenza rilevata durante il controllo qualità.",
      "finPirce": "Prezzo finale",
      "copySuccess": "Copiato con successo",
      "copyfail": "Copia non riuscita",
      "sureSuccess": "Conferma transazione completata con successo",
      "submitError": "Invio non riuscito",
      "detectionResult": "Risultato dell'ispezione",
      "Collected": "Ritirato",
      "inTransit": "In transito / Spedizione",
      "understand": "Ho capito",
      '656g0lj3sf6e': 'I bonus promozionali sono offerti e gestiti dai marchi associati. Verranno corrisposti separatamente e non fanno parte della valutazione del dispositivo usato.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Rifiuta il riciclaggio",
      "64a9shqq3k00": "Confermi di rifiutare il riciclaggio",
      "64a9shqq3r00": "Annullamento riuscito",
      "64a9shqq3ws0": "Annullamento non riuscito",
      "sureCancel": "Conferma annullamento"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Informazioni personali",
      "649fhwp9zbo0": "Carica una foto chiara del tuo pacco",
      "649fhwpa1900": "Scarica l'etichetta di spedizione",
      "649fhwpa1l00": "Scarica l'etichetta di spedizione",
      "649fhwpa1tc0": "Consegna completata",
      "649fhwpa2100": "Foto del pacco e Dichiarazione di Onestà",
      "649fhwpa2880": "Esempio di come applicare l'etichetta di spedizione",
      "649fhwpa2h80": "Nota",
      "649fhwpa2qk0": "Imballaggio: avvolgi il telefono con del pluriball e riempi la scatola con carta di giornale per evitare danni durante il trasporto.",
      "649fhwpa2xs0": "Riempi gli spazi vuoti con materiale protettivo per prevenire danni.",
      "649fhwpa3fk0": "Etichetta logistica: porta l'etichetta (digitale o stampata) al punto di consegna; l'etichetta ufficiale verrà stampata lì.",
      "649fhwpa3v40": "Ti invitiamo a spedire il tuo telefono usato il prima possibile. Se non viene spedito entro 10 giorni, l'ordine verrà annullato.",
      "649fhwpa42s0": "Ricerca punti di consegna",
      "649fhwpa4as0": "Scarica l'etichetta",
      "649fhwpa4jo0": "Caricare",
      "649fhwpa4ok0": "Home",
      "649fhwpa4to0": "Invio riuscito",
      "649fhwpa4yk0": "Congratulazioni, download completato con successo!",
      "649fhwpasf3s": "Attenzione",
      "649fhwpaa6f3": "Stampa e firma la Dichiarazione di Onestà, quindi scatta una foto insieme al pacco del dispositivo e caricala."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Social Media",
      "646d71qugz40": "Pagamento facile",
      "646u51qugz40": "Logistica",
      "646u5dqui780": "Informativa sulla privacy",
      "646uddqui780": "Termini e condizioni",
      "646u51qui780": "Domande frequenti (FAQ)"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "Informazioni su Danghuan",
      "646ntjwmn580": "Business",
      "646nt7hwils0": "Contattaci",
      "646nt7hwipg0": "Compra",
      "646nt7hwis00": "Vendi"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Valutazione gratuita"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Inserisci il modello che desideri vendere",
      "646wgb1nj8o0": "Termine di ricerca",
      "646wgb1nji80": "Ho attivato la ricerca a scorrimento",
      "empty": "Siamo spiacenti, il modello non esiste",
      "confirm": "Conferma",
      "cancle": "Annulla",
      "dialogText": "Sei sicuro di voler eliminare tutta la cronologia dei \nrecord?"
    }
  },
  "PCProduct": {
    "empty": "Siamo spiacenti, il modello non esiste"
  },
  "PCBrandTab": {
    "index": "Marca"
  },
  "PCCategoryTab": {
    "index": "Categoria"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Ordina online",
      "646xagqwkuw0": "Spedizione gratuita",
      "646xagqwmao0": "Test",
      "646xagqwmlc0": "Pagamento rapido"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Home"
    }
  },
  "router": {
    "selectModel": "Modelli",
    "selectProperty": "Problemi del dispositivo",
    "price": "Prezzo stimato",
    "priceOrder": "Effettua un ordine",
    "orderSuccess": "Ordine completato con successo"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Seleziona nuovamente il modello",
      "646ymq6ot0k0": "Promemoria",
      "646ymq6pd100": "Prima della spedizione, assicurati di disconnetterti dal tuo account cloud",
      "646ymq6pekw0": "/ blocco schermo / Apple ID sul vecchio dispositivo."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Seleziona le condizioni del dispositivo",
      "647h1f4yr6c0": "Prezzo stimato",
      "647h1f4yso80": "Bonus stimato",
      "text1": "Spedizione gratuita",
      "text2": "Offriamo un servizio di logistica e spedizione gratuito",
      "text3": "Pagamento immediato",
      "text4": "Effettueremo il pagamento entro 1-2 giorni lavorativi dal ricevimento del tuo dispositivo usato.",
      "64tve23zt0g0": "Spedizione e kit di vendita gratuiti",
      "64tve23zup00": "Cancellazione sicura dei dati",
      "64tve23zuy40": "Non sei soddisfatto? Reso gratuito",
      "64tve23zv7g0": "Il pagamento sarà effettuato entro 3 giorni lavorativi dalla ricezione del dispositivo",
      "64tve23zvbg0": "Scegli il metodo di consegna",
      "64tve23zvf80": "Hai 10 giorni per consegnare il tuo telefono.",
      "64tve23zvjc0": "Ottieni un'etichetta di spedizione gratuita e invia il tuo telefono",
      "64tve23zvms0": "Ricevi l'etichetta di spedizione via e-mail",
      "64tve23zvqg0": "Nota:",
      "64tve23zvyo0": "A causa delle restrizioni di trasporto relative alle batterie al litio, non spedire il telefono se sospetti che la batteria possa essere difettosa o danneggiata.",
      "64tve23zwak0": "Non possiamo restituire accessori o imballaggi inviati insieme al dispositivo.",
      "64tve23zwgs0": "Prossimi passaggi per vendere il tuo telefono",
      "64tve23zwm80": "Compila i tuoi dati di contatto",
      "64tve23zwt00": "Prepara il tuo telefono per la spedizione",
      "64tve23zwwk0": "Il tuo dispositivo verrà controllato al suo arrivo. Se le informazioni fornite non sono accurate, ti invieremo una nuova offerta. Puoi accettare la nuova offerta o ricevere indietro il tuo dispositivo gratuitamente."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "Canale di acquisto",
      "646ynp3ueas0": "Richiede attivazione, non può effettuare chiamate normalmente",
      "646ynp3uehw0": "Inserisci il numero IMEI",
      "646ynp3uem40": "Digita *#06# sul tastierino per visualizzare l'IMEI del telefono"
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Visualizza l'offerta"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Promemoria: il prezzo dei telefoni cellulari e dei prodotti elettronici può diminuire fino al 6%, quindi ti consigliamo di spedire il pacco il prima possibile.",
      "647hqss760c0": "Ho letto e accetto",
      "647hqss764w0": "l'Informativa sulla privacy",
      "647hqss76ac0": "Termini e condizioni",
      "647hqss76dg0": "Invia",
      "647hqss76gw0": "Prezzo totale (Valutazione del dispositivo usato)",
      "text1": "Totale",
      "text2": "Prezzo stimato",
      "text3": "Bonus stimato",
      "dialogTitle": "Avviso",
      "dialogText": "Clicca sul pulsante CONFERMA e controlla la tua e-mail per procedere al passaggio successivo",
      "dialogBtn": "CONFERMA"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Informazioni sull'ordine",
      "647kboa06ys0": "Nome",
      "647kboa0d6v8": "Prefisso internazionale",
      "647kboa078s0": "Telefono",
      "647kboa07d00": "Indirizzo",
      "647kboa07jk0": "Paese",
      "647kboa07p80": "Seleziona",
      "647kboa08b40": "CAP",
      "647kboa08h00": "Città",
      "647kboa08zc0": "Indirizzo",
      "647kboa09440": "Informazioni bancarie",
      "647kboa096w0": "Verifica e-mail",
      "647kboa09ao0": "E-mail",
      "647kboa09dk0": "Codice di verifica",
      "647kboa09u40": "Inserisci",
      "647kboa09z80": "Invia",
      "647kboa0ak00": "Errore nel formato e-mail",
      "647kboa0aog0": "Invio riuscito",
      "send": "Inviato",
      "submit": "Invia",
      "error": "Errore nel codice di verifica",
      "64jjt96fg400": "Inserisci il codice di verifica",
      "64jjt96fki00": "Richiedi il codice di verifica",
      "idNumber": "Numero di carta d'identità / ID",
      "declaration": "Dichiarazione di integrità",
      "download": "Scarica",
      "647kboa0idc0": "Documento d'identità personale",
      "647kboa0idc1": "(il numero di identificazione ufficiale rilasciato dal tuo paese, utilizzato per procedure legali, fiscali o amministrative. Può trattarsi del tuo DNI, NIE, Codice Fiscale, Numero di identificazione personale, CNP o altro documento equivalente, a seconda del paese di residenza.)",
      "647kboa0idc2": "(il numero di identificazione ufficiale rilasciato dal tuo paese, utilizzato per procedure legali, fiscali o amministrative. Può trattarsi del tuo DNI, NIE, Codice Fiscale, Numero di identificazione personale, CNP o altro documento equivalente, a seconda del paese di residenza.)",
      "idError": "Numero ID non valido",
      "ibanTip": "Utilizzato per ricevere il pagamento del vecchio dispositivo.",
      "addreddPlaceholder": "Questo campo supporta fino a 105 caratteri"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Homepage",
      "notRecyclable": "Questo tipo di dispositivo non è riciclabile",
      "IKnow": "Ho capito",
      "tips": "Suggerimenti"
    }
  },

  "blog": {
    "blogList": {
        "64wgr171lsk0": "Visualizzazioni",
        "64wgr171nq40": "Nessun contenuto correlato disponibile.",
        "64wgr171av65": "Data"
    },
    "blogDetail": {
        "64wgr9y5r7s0": "Visualizzazioni",
        "64wgr171wdx9": "Dettagli"
    }
  },

  "cookieNotice": {
    "title": "Avviso sui cookie",
    "description": "Utilizziamo i cookie per migliorare la tua esperienza di navigazione. Continuando a utilizzare questo sito, accetti la nostra",
    "cookiePolicy": "Informativa sui cookie",
    "acceptAll": "Accetta tutti i cookie",
    "acceptNecessary": "Accetta solo i cookie necessari",
    "customize": {
      "title": "Seleziona i tipi di cookie che desideri accettare:",
      "necessary": {
        "label": "Cookie necessari",
        "description": "Questi cookie sono essenziali per il funzionamento del sito web e non possono essere disabilitati."
      },
      "analytics": {
        "label": "Cookie analitici",
        "description": "Questi cookie ci aiutano a capire come i visitatori interagiscono con il nostro sito web."
      },
      "marketing": {
        "label": "Cookie di marketing",
        "description": "Questi cookie tracciano l'attività dell'utente tra i siti per offrire annunci pertinenti."
      }
    },
    "save": "Salva impostazioni",
    "cancel": "Annulla"
  }
}